import React, { useState } from "react";
import TodoItem from "./TodoItem";

function TodoList({ todos, setTodos }) {
  const [newTodo, setNewTodo] = useState("");
  const [todoError, setTodoError] = useState("");

  const namePattern = /^[\p{L}\p{N}'.-]+(?: [\p{L}\p{N}'.@-]+)* ?$/u;

  // Capitalize first letter of each word, maintain single spaces
  const formatName = (value) => {
    return value
      .toLowerCase()
      .replace(/ +/g, " ") // Replace multiple spaces with single space
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const addTodo = () => {
    if (newTodo.trim().length === 0) {
      setTodoError("cannot be empty.");
      return;
    }
    if (newTodo.length > 25) {
      setTodoError("Max 25 characters.");
      return;
    }
    if (!namePattern.test(newTodo)) {
      setTodoError("Spl chars ' . @ - allows only");
      return;
    }
    if (todos.length >= 48) {
      setTodoError("Maximum 48 Subjects.");
      return;
    }

    const formattedTodo = formatName(newTodo);

    setTodos([
      ...todos,
      { id: todos.length + 1, text: formattedTodo, isEditing: false },
    ]);
    setNewTodo("");
    setTodoError("");
  };

  const updateTodo = (id, text, isEditing = false) => {
    setTodos(
      todos.map((todo) =>
        todo.id === id
          ? { ...todo, text: isEditing ? todo.text : text, isEditing }
          : todo
      )
    );
  };

  const deleteTodo = (id) => {
    setTodos(todos.filter((todo) => todo.id !== id));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
      <h2 style={{ fontSize: "20px", color: "#6c63ff" }}>
        Enter Subjects or Edit Below
      </h2>

      {/* Input and Add Button */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={newTodo}
          onChange={(e) => {
            const formattedInput = formatName(e.target.value);
            setNewTodo(formattedInput);
            setTodoError(""); // Reset the error as the user types
          }}
          placeholder="Add upto 48 Subjects"
          style={{
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
          }}
        />
        <button
          type="button"
          onClick={addTodo}
          style={{
            padding: "10px 10px",
            backgroundColor: "#6c63ff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Add Subjects
        </button>
      </div>

      {/* Error Message */}
      {todoError && (
        <p style={{ color: "red", fontSize: "14px" }}>{todoError}</p>
      )}

      {/* Todos List */}
      <ul style={{ paddingLeft: "0px", listStyle: "none" }}>
        {todos.map((todo, index) => (
          <TodoItem
            key={todo.id}
            todo={todo}
            serial={index + 1} // Pass serial number
            updateTodo={updateTodo}
            deleteTodo={deleteTodo}
          />
        ))}
      </ul>
    </div>
  );
}

export default TodoList;
